import { motion } from "framer-motion";
import { ReactTyped } from "react-typed";
import { Github, Linkedin } from "lucide-react";

export default function Hero() {
  return (
    <section className="min-h-screen flex flex-col justify-center items-center text-center bg-gray-950 px-6">
      <motion.h2
        initial={{ opacity: 0, y: -30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="text-3xl md:text-5xl font-bold text-white mb-4"
      >
        Hello,I'm Chandu<br></br>
         I'm an{" "}
        <span className="text-red-500">
          <ReactTyped
            strings={["AI Engineer", "ML Developer"]}
            typeSpeed={80}
            backSpeed={60}
            loop
          />
        </span>
      </motion.h2>

      <motion.p
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.5, duration: 0.8 }}
        className="mb-6 text-gray-300 max-w-xl"
      >
        Passionate about building real-time AI systems. I’ve completed an AI internship and developed multiple impactful projects.
      </motion.p>

      <motion.div
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.8 }}
        className="flex gap-4 mb-6 flex-wrap justify-center"
      >
        <a
          href="#experience"
          className="bg-red-600 px-6 py-3 rounded hover:bg-red-700 transition"
        >
          Experience
        </a>
        <a
          href="#projects"
          className="bg-red-600 px-6 py-3 rounded hover:bg-red-700 transition"
        >
          Projects
        </a>
      </motion.div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1 }}
        className="flex gap-6"
      >
        <a
          href="https://github.com/Chandu2308"
          target="_blank"
          rel="noopener noreferrer"
          className="text-gray-300 hover:text-white"
        >
          <Github size={28} />
        </a>
        <a
          href="https://www.linkedin.com/in/chandu-nangunoori-2b98ab269/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-gray-300 hover:text-white"
        >
          <Linkedin size={28} />
        </a>
      </motion.div>
    </section>
  );
}
